import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { SwitchFieldComponent } from './../switch-field.component';

@Component({
  selector: 'app-basic-field-number',
  templateUrl: './basic-field-number.component.html',
  styleUrls: ['./../Field-Styles.scss'],
})
export class BasicFieldNumberComponent extends SwitchFieldComponent implements OnInit {
  @Input() public RealValue;
  @Input() public Title: string = "Unset";
  
  @Input() MaxNumsAfterDot: number = 3;

  // write comp values
  @Input() ShowRealVal: boolean = false;
  @Input() MaxVal: number;
  @Input() MinVal: number;

  // decore
  @Input() public Comment: string = "";
  @Input() public FrontDecor: string = "";
  @Input() public RearDecor: string = "";

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
